import { PublicSeoHreflangLink } from '.';
import { OgPayload } from './resources/seo/og-payload';
import { PageSeoPayload } from './resources/seo/page-seo-payload';

/**
 * Port: abstract contract for DOM SEO meta manipulation.
 * Abstract class (not interface) to support Angular DI token injection.
 */
export abstract class SeoMetaPort {
    /** Set or replace the <link rel="canonical"> tag */
    public abstract setCanonical(url: string): void;

    /** Clear all existing hreflangs, then add the provided entries */
    public abstract setHreflangs(links: ReadonlyArray<PublicSeoHreflangLink>): void;

    /** Set or update <meta name="robots"> */
    public abstract setRobots(content: string): void;

    /** Remove ALL <link rel="alternate"> elements from <head> */
    public abstract clearHreflangs(): void;

    /** Set the lang attribute on the <html> element */
    public abstract setHtmlLang(lang: string): void;

    /** Set title + description + keywords for current route */
    public abstract setPageSeo(payload: PageSeoPayload): void;

    /**
     * Set all Open Graph and Twitter Card meta tags synchronously.
     * Uses updateTag() (idempotent) for both property-based (og:*) and name-based (twitter:*, fb:pages) tags.
     */
    public abstract setOpenGraph(payload: OgPayload): void;

    /** Clear previous managed preloads and add provided font hrefs */
    public abstract setPreloads(hrefs: ReadonlyArray<string>): void;

    /** Set (or remove, when null) the managed JSON-LD structured data block */
    public abstract setJsonLd(json: string | null): void;
}
